import { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/hooks'
import {
  selectSessionExpiryWarning,
  renewSessionAsync,
  logoutAsync,
  dismissSessionExpiryWarning,
} from 'store/authslice'

const COUNTDOWN_SECONDS = 1 * 60

const SessionExpiryDialog = () => {
  const dispatch = useAppDispatch()
  const show = useSelector(selectSessionExpiryWarning)
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS)

  useEffect(() => {
    if (!show) {
      document.title = document.title.replace(/^⚠️ .+ - /, '')
      setSecondsLeft(COUNTDOWN_SECONDS)
      return
    }

    const interval = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          clearInterval(interval)
          return 0
        }
        return s - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [show])

  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60
  const countdown = `${minutes}:${String(seconds).padStart(2, '0')}`

  useEffect(() => {
    if (!show) return
    const baseTitle = document.title.replace(/^⚠️ .+ - /, '')
    document.title = `⚠️ ${countdown} - ${baseTitle}`
  }, [show, countdown])

  const handleRenew = () => {
    dispatch(dismissSessionExpiryWarning())
    dispatch(renewSessionAsync())
  }

  const handleLogout = () => {
    dispatch(dismissSessionExpiryWarning())
    dispatch(logoutAsync())
  }

  return (
    <Modal show={show} centered backdrop="static" keyboard={false} aria-labelledby="session-expiry-title">
      <Modal.Header>
        <Modal.Title id="session-expiry-title">Din session håller på att gå ut</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Du kommer att loggas ut automatiskt om <strong>{countdown}</strong> på grund av inaktivitet.
        </p>
        <p className="mb-0">Vill du förlänga din session?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleLogout}>
          Logga ut
        </Button>
        <Button variant="primary" onClick={handleRenew}>
          Ja, förläng session
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SessionExpiryDialog
